'use strict';

module.exports = /*@ngInject*/
function() {
    return {
        scope: {
            catIndex: '=childCatColumns'
        },
        link: function(scope, element, attrs) {
            if (scope.catIndex >= 0 && scope.catIndex <= 4) {
                jQuery(element).addClass('column-1-' + attrs.rootCatId);
            } else if (scope.catIndex >= 5 && scope.catIndex <= 9) {
                jQuery(element).addClass('column-2-' + attrs.rootCatId);
            } else if (scope.catIndex >= 10 && scope.catIndex <= 14) {
                jQuery(element).addClass('column-3-' + attrs.rootCatId);
            } else if (scope.catIndex >= 15 && scope.catIndex <= 19) {
                jQuery(element).addClass('column-4-' + attrs.rootCatId);
            } else if (scope.catIndex >= 20 && scope.catIndex <= 24) {
                jQuery(element).addClass('column-5-' + attrs.rootCatId);
            } else if (scope.catIndex >= 25 && scope.catIndex <= 29) {
                jQuery(element).addClass('column-6-' + attrs.rootCatId);
            }
        }
    };
};
